import { Injectable } from '@angular/core';
import { Store, Action } from '@ngrx/store';
import { Response } from '@angular/http';

import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../reducers';
import { TicketQuotaActions } from '../actions';
import { MessageActions } from '../actions/message.actions';

import { TicketQuota, TicketQuotaMessage } from '../models';
import { TicketQuotaApi } from '../services/webservice'
import { TicketQuotaHandlingService } from '../services';
import { ErrorHandlerService } from '../services/index'
import { UnsafeAction } from '../actions/UnsafeAction';

/* tslint:disable */
@Injectable()
export class TicketQuotaEffect {
	constructor(
		private updates$: Actions,
		private store: Store<AppState>,
		private ticketQuotaActions: TicketQuotaActions,
		private messageActions: MessageActions,
		private ticketQuotaApi: TicketQuotaApi,
		private errorHandler: ErrorHandlerService
	) { }

	@Effect() setSelectedTicketQuota$ = this.updates$
		.ofType(TicketQuotaActions.SET_SELECTED_TICKETQUOTA)
		.map((action: UnsafeAction) => action.payload)
		.map(ticketQuota => {
			//if (ticketQuota) return this.ticketQuotaActions.loadTicketQuotaMessages(ticketQuota._links.ticketQuotaConfigMessages.href)
			//else
			return { type: "" }
		})

	@Effect() loadTicketQuotaCollection$ = this.updates$
		.ofType(TicketQuotaActions.LOAD_COLLECTION)
		.map(toPayload)
		.flatMap(collectionUrl => this.ticketQuotaApi.getTicketQuotas(collectionUrl)
			.flatMap(ticketQuotaCollection => Observable.concat([
				this.ticketQuotaActions.loadCollectionSuccess(ticketQuotaCollection),
				this.ticketQuotaActions.setSelectedTicketQuota(
					TicketQuotaHandlingService.getStandardTicketQuotaOrFirstOrNull(ticketQuotaCollection._embedded.ticketQuotas)
				)
			]))
			.catch((error) => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() refreshTicketQuotaCollection$ = this.updates$
		.ofType(TicketQuotaActions.REFRESH_COLLECTION)
		.map(toPayload)
		.flatMap(collectionUrl => this.ticketQuotaApi.getTicketQuotas(collectionUrl)
			.map(ticketQuotaCollection => this.ticketQuotaActions.refreshCollectionSuccess(ticketQuotaCollection))
			.catch((error) => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() createTicketQuota$ = this.updates$
		.ofType(TicketQuotaActions.CREATE_TICKETQUOTA)
		.map(toPayload)
		.flatMap(ticketQuota => this.ticketQuotaApi.createTicketQuota(ticketQuota)
			.map(newTicketQuota => this.ticketQuotaActions.createTicketQuotaSuccess(newTicketQuota))
			.catch((error) => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten. Das Kontingent konnte nicht gespeichert werden."))
		)

	@Effect() createTicketQuotaSuccess$ = this.updates$
		.ofType(TicketQuotaActions.CREATE_TICKETQUOTA_SUCCESS)
		.mapTo(this.ticketQuotaActions.linkTicketQuotas())

	@Effect() linkTicketQuota$ = this.updates$
		.ofType(TicketQuotaActions.LINK_TICKETQUOTAS)
		.withLatestFrom(this.store)
		.flatMap(([action,state]) => this.ticketQuotaApi.linkTicketQuota(state.eventServerState.ticketQuotas.collectionUrl,
			this.collectTicketQuotaUrls(state.eventServerState.ticketQuotas.ticketQuotaCollection))
			.flatMap(() => Observable.concat(
				[
					this.ticketQuotaActions.refreshCollection(state.eventServerState.ticketQuotas.collectionUrl),
					this.messageActions.displayMessage("Das Kontingent wurde erfolgreich angelegt!", "success")
				]
			)
			.catch((error) => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten. Das Kontingent konnte nicht gespeichert werden."))
		))

	@Effect() updateTicketQuota$ = this.updates$
		.ofType(TicketQuotaActions.UPDATE_TICKETQUOTA)
		.map(toPayload)
		.flatMap(ticketQuota => this.ticketQuotaApi.updateTicketQuota(ticketQuota)
			.map(updatedTicketQuota => this.ticketQuotaActions.updateTicketQuotaSuccess(updatedTicketQuota))
			.catch((error) => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten. Das Kontingent konnte nicht gespeichert werden."))
		)

	@Effect() updateTicketQuotaSuccess$ = this.updates$
		.ofType(TicketQuotaActions.UPDATE_TICKET_QUOTA_SUCCESS)
		.withLatestFrom(this.store)
		.flatMap(([action, state]) => Observable.concat(
			[
				this.ticketQuotaActions.refreshCollection(state.eventServerState.ticketQuotas.collectionUrl),
				this.messageActions.displayMessage("Das Kontingent wurde erfolgreich gespeichert!", "success")
			]
		));

	@Effect() deleteTicketQuota$ = this.updates$
		.ofType(TicketQuotaActions.DELETE_TICKET_QUOTA)
		.map(toPayload)
		.flatMap(ticketQuotaToBeDeleted => this.ticketQuotaApi.deleteTicketQuota(ticketQuotaToBeDeleted)
			.mapTo(this.ticketQuotaActions.deleteTicketQuotaSuccess(ticketQuotaToBeDeleted))
			.catch((error) => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten. Das Kontingent konnte nicht gelöscht werden."))
		)

	@Effect() deleteTicketQuotaSuccess$ = this.updates$
		.ofType(TicketQuotaActions.DELETE_TICKET_QUOTA_SUCCESS)
		.mapTo(this.messageActions.displayMessage("Das Kontingent wurde erfolgreich gelöscht!", "success"))

	@Effect() deleteTicketQuotaSuccessSelectNewItem$ = this.updates$
		.ofType(TicketQuotaActions.DELETE_TICKET_QUOTA_SUCCESS)
		.withLatestFrom(this.store)
		.map(([action,state]) => this.ticketQuotaActions.setSelectedTicketQuota(
			TicketQuotaHandlingService.getStandardTicketQuotaOrFirstOrNull(state.eventServerState.ticketQuotas.ticketQuotaCollection)
		));

	@Effect() loadTicketQuotaMessages$ = this.updates$
		.ofType(TicketQuotaActions.LOAD_TICKETQUOTA_MESSAGES)
		.map(toPayload)
		.flatMap(ticketQuotaMessageUrl => this.ticketQuotaApi.loadTicketQuotaMessages(ticketQuotaMessageUrl)
			.map(ticketQuotaMessages => this.ticketQuotaActions.loadTicketQuotaMessagesSuccess(ticketQuotaMessages))
			.catch((error) => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	@Effect() postTicketQuotaMessage$ = this.updates$
		.ofType(TicketQuotaActions.POST_TICKETQUOTA_MESSAGE)
		.withLatestFrom(this.store)
		.flatMap(([action,state]: [UnsafeAction, AppState]) => this.ticketQuotaApi.postTicketQuotaMessage(state.eventServerState.ticketQuotas.selectedTicketQuota._links.ticketQuotaMessages.href,
			action.payload)
			.flatMap(ticketQuota => Observable.concat(
				[
					this.ticketQuotaActions.setSelectedTicketQuota(ticketQuota),
					this.ticketQuotaActions.updateTicketQuotaSuccess(ticketQuota),
					this.messageActions.displayMessage("Ihre Kontingentmeldung ware erfolgreich.", "success")
				]
			))
			.catch((error) => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten. Die Kontingentmeldung konnte nicht gespeichert werden."))
		)

	@Effect() reloadTicketQuota$ = this.updates$
		.ofType(TicketQuotaActions.RELOAD_TICKETQUOTA)
		.map(toPayload)
		.flatMap(ticketQuotaId => this.ticketQuotaApi.getTicketQuota(ticketQuotaId)
			.flatMap(ticketQuota => Observable.concat([
				this.ticketQuotaActions.reloadTicketQuotaSuccess(ticketQuota),
				this.ticketQuotaActions.setSelectedTicketQuota(ticketQuota)
			]))
			.catch((error) => this.handleError(error, "Es ist ein unerwarteter Fehler aufgetreten."))
		)

	private handleError(error:Response, defaultMessage:string):Observable<Action> {
		let errorMessage = this.errorHandler.getErrorMessage(error,	defaultMessage)
		return Observable.of(this.messageActions.displayMessage(errorMessage, "error"))
	}

	private collectTicketQuotaUrls(ticketQuotas:TicketQuota[]):string[] {
		return ticketQuotas.map(ticketQuota => ticketQuota._links.self.href)
	}

}



// WEBPACK FOOTER //
// ./src/app/effects/ticket-quota.effect.ts